import Dialog from './src'

Dialog.install = Vue => {
  Vue.component(Dialog.name, Dialog)
}

export default Dialog
